// Module
var code = `<tour-step-body><span translate="activity-editor_default-marker-set-tour-body"></span></tour-step-body>`;
// Exports
export default code;